import slice from "./helpSlice";

export default slice.reducer;
